import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "job" }
const _hoisted_2 = {
  key: 0,
  class: "logo"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "info" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "period ellipsis" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.job.logo_url)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: $props.job.logo_url
          }, null, 8 /* PROPS */, _hoisted_3)
        ]))
      : (_openBlock(), _createBlock(_component_Icon, {
          key: 1,
          icon: "building-08",
          stroke: "#1D2939",
          "stroke-width": "1.5",
          width: "2.4rem",
          height: "2.4rem"
        })),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "position ellipsis",
        innerHTML: $props.job.position
      }, null, 8 /* PROPS */, _hoisted_5),
      _createElementVNode("div", {
        class: "company ellipsis",
        innerHTML: $props.job.company
      }, null, 8 /* PROPS */, _hoisted_6),
      _createElementVNode("div", _hoisted_7, _toDisplayString($options.makePeriod($props.job.start, $props.job.end)), 1 /* TEXT */)
    ])
  ]))
}